module.exports = __webpack_public_path__ + "static/img/bg21.155c79c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg21.jpg
// module id = p3hn
// module chunks = 1